var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 645 230.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 22.2,
    y1: 147.89,
    x2: 203.65,
    y2: 147.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42c1b6"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_data_simpl_02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M211.4,213.5h4.4l6.7,13,6.6-13h4.4v20.2H230V219.2l-6.3,12.4h-2.5L215,219.2v14.5h-3.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,233.7l-1.8-4.3h-9.9l-1.8,4.3h-4l8.9-20.2h4l8.7,20.2Zm-10.3-7.6H259l-3.5-8.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.4,233.7h-4.6l-6.3-8.7-3.2,3.5v5.2h-3.9V213.5h3.9v10.1l9.1-10.1h4.6l-7.8,8.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,213.5h14.8v3.4H310.9v5h9.8v3.4h-9.8v5.1h11.3v3.4H307Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,214.8a9.4,9.4,0,0,1,3.8,3.6,10.1,10.1,0,0,1,1.4,5.2,10,10,0,0,1-1.4,5.2,9.6,9.6,0,0,1-3.8,3.6,11.5,11.5,0,0,1-5.5,1.3h-8.2V213.5h8.4A11.3,11.3,0,0,1,374,214.8Zm-2,14.7a6,6,0,0,0,2.3-2.4,7.5,7.5,0,0,0,0-6.9,6.1,6.1,0,0,0-2.4-2.4,6.8,6.8,0,0,0-3.4-.9h-4.5v13.4h4.6A6.6,6.6,0,0,0,372,229.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,233.7l-1.8-4.3h-9.9l-1.8,4.3h-4l8.9-20.2h4l8.7,20.2Zm-10.3-7.6h7.1l-3.5-8.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.5,213.5H433V217h-6.3v16.8h-3.9V217h-6.3Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.3,233.7l-1.8-4.3h-9.9l-1.8,4.3h-4l8.9-20.2h4l8.7,20.2ZM447,226.1h7.1l-3.5-8.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.6,217.2a9.6,9.6,0,0,0-2.9-.5,4,4,0,0,0-2.2.5,1.6,1.6,0,0,0-.8,1.4,1.9,1.9,0,0,0,.6,1.4,4.4,4.4,0,0,0,1.4.9l2.3.8,3.4,1.2a6,6,0,0,1,2.2,1.8,4.9,4.9,0,0,1,.9,3.1,5.3,5.3,0,0,1-1,3.2,6.2,6.2,0,0,1-2.7,2.1,10.4,10.4,0,0,1-4,.7,12.6,12.6,0,0,1-4.6-.9,13.1,13.1,0,0,1-3.9-2.4l1.6-3.3a11.8,11.8,0,0,0,3.4,2.2,9.1,9.1,0,0,0,3.5.8,4.5,4.5,0,0,0,2.5-.6,2,2,0,0,0,.4-3.1,4.2,4.2,0,0,0-1.4-.9l-2.4-.8-3.3-1.2a5.8,5.8,0,0,1-2.2-1.7,4.8,4.8,0,0,1-.9-3.1,5.1,5.1,0,0,1,.9-3.1,6,6,0,0,1,2.7-2,10.2,10.2,0,0,1,4-.7,13.4,13.4,0,0,1,3.9.6,13.1,13.1,0,0,1,3.4,1.6l-1.6,3.4A14.6,14.6,0,0,0,543.6,217.2Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.9,213.5h3.9v20.2h-3.9Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.5,213.5H577l6.7,13,6.6-13h4.4v20.2h-3.5V219.2l-6.3,12.4h-2.5l-6.3-12.4v14.5h-3.5Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.6,215.3a6.4,6.4,0,0,1,2.1,5.1,6.9,6.9,0,0,1-2.1,5.4,8.4,8.4,0,0,1-5.9,1.9h-4.4v5.9h-3.9V213.5h8.3A8.7,8.7,0,0,1,619.6,215.3Zm-2.7,8.1a3.4,3.4,0,0,0,1.2-2.8,3.3,3.3,0,0,0-1.2-2.8,5.3,5.3,0,0,0-3.4-.9h-4.2v7.5h4.2A5.2,5.2,0,0,0,616.8,223.4Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.6,213.5h3.9v16.7h8.7v3.5H630.6Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652,213.5h14.8v3.4H655.9v5h9.8v3.4h-9.8v5.1h11.3v3.4H652Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.6,32.4A17.2,17.2,0,0,1,244,49.8c0,10.4-7.7,18.1-17.4,18.1s-18.1-7.6-18.1-18.1,7.7-17.4,18.1-17.4ZM212,199.4V79.7h28.5V199.4Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#1a8ff7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.1 181.9 616.1 17 644.6 17 644.6 181.9 616.1 181.9 616.1 181.9",
    style: {
      fill: "#1a8ff7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,199.6v-73a26.1,26.1,0,0,1,25.7-25.7h0c14.6,0,26.4,11.8,26.4,25.7v73h28.5V127.3a55.1,55.1,0,0,0-55-55h0a53.6,53.6,0,0,0-40.3,18.1,53.7,53.7,0,0,0-40.4-18.1h0a55.1,55.1,0,0,0-55,55v72.3h29.2v-73a25.7,25.7,0,0,1,25.7-25.7h0a26.1,26.1,0,0,1,25.7,25.7v.7h0v72.3h29.2Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#1a8ff7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.3,173c-20.2,0-36.2-16.7-36.2-36.9A36.4,36.4,0,0,1,549.3,100c20.2,0,36.9,16.7,36.9,36.2A37.1,37.1,0,0,1,549.3,173Zm0-101.6a65,65,0,0,0-64.7,64.7V248h27.8V189.7c11.6,7.6,23.3,11.8,36.5,11.8,36.2,0,64.9-29.2,64.9-65.4a64.4,64.4,0,0,0-64.5-64.7Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#1a8ff7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.2,60.5V20.7h9V33.2H268v8h-5.8V60.5c0,2.2.9,3.2,3.2,3.2H268v8h-3.4c-6,0-11.4-3.4-11.4-11.2Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.2,63a11.2,11.2,0,1,1,11.2-11.2A11.1,11.1,0,0,1,226.2,63Zm-.1-31.2a20,20,0,0,0,.1,40,19.4,19.4,0,0,0,11.2-3.4v3.3H246V51.8a20,20,0,0,0-19.9-20Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,62.9a11.2,11.2,0,1,1,11.2-11.2A11.1,11.1,0,0,1,291,62.9Zm-.1-31.2a20,20,0,0,0,.1,40,19.4,19.4,0,0,0,11.2-3.4v3.3h8.6V51.7a20,20,0,0,0-19.9-20Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.1,63a11.2,11.2,0,1,1,0-22.4,11.2,11.2,0,1,1,0,22.4Zm11.3-45.8V35.3a21.4,21.4,0,0,0-11.3-3.4,20,20,0,1,0,19.9,20V17.2Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#0000ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,134.3,168.2,79.4a27.1,27.1,0,0,0-23.5-13.5v0H81.1A27.1,27.1,0,0,0,57.6,79.4L25.9,134.3a27.1,27.1,0,0,0,0,27.2l31.8,54.9a27.1,27.1,0,0,0,23.5,13.5h63.6a27.1,27.1,0,0,0,23.5-13.5L200,161.5a27.1,27.1,0,0,0,0-27.2Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "url(#New_Gradient_Swatch_1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,169.2c0,28.2,28.9,41.9,57.8,42.6,38.3,0,55.6-19.5,56.4-39,.7-30.3-28.2-38.3-54.2-41.9-17.3-2.9-26-4.3-25.3-13s13.7-10.9,21.7-10.9,23.1,2.9,23.1,14.5h29.6c-.7-25.3-21.7-41.9-52-42.6S63.2,93.3,61.8,116.5c-2.9,34.7,38.3,40.5,51.3,42.6,17.4,2.2,26.7,5.8,28.2,11.6,1.5,9.4-8.7,13-25.3,13-21.7,0-27.5-10.1-28.9-14.4Z",
    transform: "translate(-22.2 -17.2)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.51c29bbe0bd97a99880739c586b98aee.svg";
export { ForwardRef as ReactComponent };